import * as React from 'react';
import { deleteDeclaration, editDeclaration } from '../../../../../../services/verisk/reducer';
import { getIncludedResource } from '../../../../../../data/api/util';
import { Button, Col, Row } from 'react-bootstrap';

export default class DeclaredConditions extends React.Component<any, any> {
  private handleDelete = (declaration) => () => {
    const { dispatch } = this.props;

    dispatch(deleteDeclaration(declaration.attributes.group, declaration.attributes.conditions[ 0 ]));
  }

  private handleEdit = (declaration) => () => {
    const { dispatch } = this.props;

    dispatch(editDeclaration(declaration.id));
  }

  public render() {
    const { screening, isControlGroup } = this.props;

    const declaredConditions = getIncludedResource(
      screening.declaredConditions.data,
      screening.declaredConditions.included,
      'conditions',
      true,
    );

    return (
      <div className="declared-conditions">
        {declaredConditions.length ? declaredConditions.map((declaration, declarationIndex) => {
          const conditionsLength = declaration.attributes.conditions?.length || 0;
          const groupNumber = declaration.attributes.group
          return (
            <div key={declarationIndex}>
              <Row className="condition">
                <Col xs={isControlGroup ? 6 : 8}>
                  {declaration.attributes.conditions.map((condition, conditionIndex) => {
                    const shouldAddComma = conditionsLength > 1 && conditionIndex <= conditionsLength - 2;
                    if (conditionIndex === 0) {
                      return (
                        <h4 key={conditionIndex} className="primary-condition">
                          {condition}
                        </h4>
                      );
                    }
                    return (
                      <span key={conditionIndex} className="linked-condition">{shouldAddComma ? condition + ', ' : condition}</span>
                    );
                  })}
                </Col>
                <Col xs={isControlGroup ? 6 : 8}>
                  <div className="reverse-buttons">
                    <Button
                      bsStyle="primary"
                      bsSize="sm"
                      className="pull-right margin-bottom declared-conditions-button remove"
                      disabled={screening.isDeleting === groupNumber}
                      onClick={this.handleDelete(declaration)}
                    >
                      Remove
                    </Button>
                    <Button
                      bsStyle="primary"
                      bsSize="sm"
                      className="pull-right margin-bottom declared-conditions-button edit"
                      disabled={screening.isEditing === declaration.id}
                      onClick={this.handleEdit(declaration)}
                    >
                      Edit
                    </Button>
                   </div>
                </Col>
              </Row>
            </div>
          );
        }) : null}
      </div>
    );
  }
}
